import { useEffect, useRef, useState } from "react";

export const useDebounce = <T>(value: T, delay: number): T => {
	// State and setters for debounced value
	const [debouncedValue, setDebouncedValue] = useState<T>(() => value);
	const timeoutRef = useRef<NodeJS.Timeout>();
	const valueRef = useRef<T>(value);

	useEffect(() => {
		// Update the ref with the current value
		valueRef.current = value;

		// Clear existing timeout
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current);
		}

		// Set new timeout
		timeoutRef.current = setTimeout(() => {
			setDebouncedValue(valueRef.current);
		}, delay);

		// Cleanup on unmount
		return () => {
			if (timeoutRef.current) {
				clearTimeout(timeoutRef.current);
			}
		};
	}, [value, delay]); // Only re-call effect if value or delay changes

	return debouncedValue;
};
